/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_Faq_Q3Inputs */

const en_guide_json_rest_api_faq_q3 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should API responses be minified or formatted?`)
};

const ko_guide_json_rest_api_faq_q3 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 응답은 압축해야 하나요, 포맷해야 하나요?`)
};

const ja_guide_json_rest_api_faq_q3 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API レスポンスは圧縮すべきですか、整形すべきですか?`)
};

/**
* | output |
* | --- |
* | "Should API responses be minified or formatted?" |
*
* @param {Guide_Json_Rest_Api_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_faq_q3 = /** @type {((inputs?: Guide_Json_Rest_Api_Faq_Q3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_Faq_Q3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_faq_q3(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_faq_q3(inputs)
	return ja_guide_json_rest_api_faq_q3(inputs)
});